export enum enmActionType {
    ACCOM_BASED = 0, ENTRY_BASED = 1
}